import { HStack, Text, VStack } from "@chakra-ui/react";
import { UserFragment } from "gql/graphql";
import { isEmpty } from "lodash";
import { OutOfOfficeIcon } from "modules/icons";
import React, { memo } from "react";
import colors from "app/colors";
import {
  isUserOutOfOffice,
  getUserOutOfOfficeNote,
} from "modules/utils/Functions";

interface IProps {
  user: UserFragment;
}

const UserPopoverOutOfOfficeInfo = ({ user }: IProps) => {
  const outOfOffice = user.outOfOffice;

  if (!outOfOffice) return null;

  if (!isUserOutOfOffice(user)) return null;

  return (
    <VStack p={2} bg={colors.yellow20} borderRadius={4} w="full" spacing={0}>
      <HStack spacing={1} w="full">
        <OutOfOfficeIcon fill={colors.yellowDark} boxSize={4} />
        <Text fontSize={11} fontWeight={500} color={colors.gray50}>
          {getUserOutOfOfficeNote(outOfOffice)}
        </Text>
      </HStack>
      {outOfOffice.message && !isEmpty(outOfOffice.message.trim()) && (
        <Text
          fontSize={11}
          fontWeight={400}
          w="full"
          color={colors.grayMain}
          lineHeight="100%"
        >
          “{outOfOffice.message}”
        </Text>
      )}
    </VStack>
  );
};

export default memo(UserPopoverOutOfOfficeInfo);
